(function () {
  'use strict';
  var M = window.MONARCH || { routes: {}, strings: {} };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Format money using the STORE's own money format so drawer prices
     always match the rest of the site (decimals, separators, currency). */
  function money(cents){
    try {
      var format = M.moneyFormat || '{{amount}}';
      var ph = /\{\{\s*(\w+)\s*\}\}/;
      function fmt(number, precision, thousands, decimal){
        if(number == null || isNaN(number)) number = 0;
        precision = (precision == null) ? 2 : precision;
        thousands = (thousands == null) ? ',' : thousands;
        decimal   = (decimal   == null) ? '.' : decimal;
        var val = (number/100).toFixed(precision);
        var parts = val.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var m = format.match(ph);
      var key = m ? m[1] : 'amount';
      var value;
      switch(key){
        case 'amount':                                   value = fmt(cents, 2, ',', '.'); break;
        case 'amount_no_decimals':                       value = fmt(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator':              value = fmt(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator':  value = fmt(cents, 0, '.', ','); break;
        case 'amount_with_space_separator':              value = fmt(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator':  value = fmt(cents, 0, ' ', ''); break;
        case 'amount_with_apostrophe_separator':         value = fmt(cents, 2, "'", '.'); break;
        default:                                         value = fmt(cents, 2, ',', '.');
      }
      return format.replace(ph, value).replace(/<[^>]*>/g, '').trim();
    } catch(e){ return (cents/100).toFixed(0) + ' kr'; }
  }

  function startReveals(skipHero){
    var els = document.querySelectorAll('.r');
    if(reduce || !('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(ents,obs){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); obs.unobserve(e.target); } });
    },{ threshold:.12, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(el){
      if(skipHero && el.closest('.hero')) return;
      io.observe(el);
    });
  }

  function initHeader(){
    var h = document.querySelector('[data-header]'); if(!h) return;
    var f = function(){ h.classList.toggle('is-scrolled', window.scrollY>8); };
    window.addEventListener('scroll', f, {passive:true}); f();
  }

  function initMenu(){
    var menu=document.querySelector('[data-mobile-menu]'), open=document.querySelector('[data-menu-open]');
    if(!menu||!open) return;
    function openMenu(){ menu.classList.add('is-open'); menu.setAttribute('aria-hidden','false'); document.body.classList.add('u-noscroll'); }
    function closeMenu(){ menu.classList.remove('is-open'); menu.setAttribute('aria-hidden','true'); document.body.classList.remove('u-noscroll'); }
    open.addEventListener('click', openMenu);
    document.querySelectorAll('[data-menu-close]').forEach(function(b){ b.addEventListener('click', closeMenu); });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeMenu(); });
  }

  function initSwatches(){
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      var input=form.querySelector('[data-variant-input]');
      var scope=form.closest('[data-section]')||document;
      var gallery=scope.querySelector('[data-gallery]');
      form.querySelectorAll('.swatch input').forEach(function(radio){
        radio.addEventListener('change',function(){
          if(input) input.value=radio.getAttribute('data-variant-id');
          form.querySelectorAll('.swatch').forEach(function(s){ s.classList.remove('is-active'); });
          var lab=radio.closest('.swatch'); if(lab) lab.classList.add('is-active');
          var fi=radio.getAttribute('data-featured-index');
          if(gallery && fi!==null){
            var thumb=gallery.querySelector('[data-thumb][data-index="'+fi+'"]');
            if(thumb) thumb.click();
          }
          var idx=radio.getAttribute('data-index');
          scope.querySelectorAll('[data-variant-image]').forEach(function(img){
            img.classList.toggle('is-active', img.getAttribute('data-variant-image')===idx);
          });
        });
      });
    });
  }

  function initFaq(){
    document.querySelectorAll('.faq__q').forEach(function(q){
      q.addEventListener('click',function(){
        var item=q.closest('.faq__item'), a=item.querySelector('.faq__a');
        var open=item.classList.toggle('open');
        q.setAttribute('aria-expanded', open?'true':'false');
        a.style.maxHeight = open ? a.scrollHeight+'px' : 0;
      });
    });
  }

  /* Cart */
  function lockScroll(on){ document.body.classList.toggle('u-noscroll', !!on); }
  function openDrawer(){ var d=document.querySelector('[data-cart-drawer]'); if(d){ d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); lockScroll(true); } }
  function closeDrawer(){ var d=document.querySelector('[data-cart-drawer]'); if(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); lockScroll(false); } }
  function freeShipHtml(total){
    var t=M.freeShip||0;
    if(!t) return '';
    if(total>=t){
      return '<div class="freeship freeship--done"><span class="freeship__msg">'+(M.strings.freeUnlocked||"You've unlocked free shipping")+' &#10003;</span><div class="freeship__track"><i style="width:100%"></i></div></div>';
    }
    var remain=t-total;
    var pct=Math.max(4,Math.min(99,Math.round(total/t*100)));
    var msg=(M.strings.freeProgress||'Add {{ amount }} more for free shipping').replace('{{ amount }}',money(remain));
    return '<div class="freeship"><span class="freeship__msg">'+msg+'</span><div class="freeship__track"><i style="width:'+pct+'%"></i></div></div>';
  }

  function render(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(c){ c.textContent=cart.item_count; });
    var body=document.querySelector('[data-cart-body]'), total=document.querySelector('[data-cart-total]');
    if(total) total.textContent=money(cart.total_price);
    if(!body) return;
    if(!cart.items.length){ body.innerHTML='<p style="color:var(--muted)">'+(M.strings.empty||'Your cart is empty.')+'</p>'; return; }
    var fs=freeShipHtml(cart.total_price);
    body.innerHTML=fs+cart.items.map(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2'):'';
      var url=it.url||'#';
      var media=img?'<a href="'+url+'"><img src="'+img+'" alt="" width="62" height="62"></a>':'<a href="'+url+'" class="cd-noimg" aria-hidden="true"></a>';
      return '<div class="cd-item">'+media+'<div>'+
        '<a href="'+url+'" style="font-family:var(--serif);font-size:1.1rem;color:var(--navy)">'+it.product_title+'</a>'+
        '<div style="font-size:.8rem;color:var(--muted)">'+(it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:'')+'</div>'+
        '<div class="cd-qty" role="group" aria-label="Quantity">'+
          '<button type="button" data-qty="'+it.key+'" data-to="'+(it.quantity-1)+'" aria-label="Decrease">&minus;</button>'+
          '<span>'+it.quantity+'</span>'+
          '<button type="button" data-qty="'+it.key+'" data-to="'+(it.quantity+1)+'" aria-label="Increase">+</button>'+
        '</div>'+
        '<div style="font-size:.85rem;margin-top:4px">'+money(it.final_line_price)+'</div>'+
        '</div>'+
        '<a href="#" data-remove="'+it.key+'" aria-label="Remove">&times;</a></div>';
    }).join('');
    body.querySelectorAll('[data-remove]').forEach(function(a){
      a.addEventListener('click',function(e){ e.preventDefault(); change(a.getAttribute('data-remove'),0); });
    });
    body.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click',function(){ change(b.getAttribute('data-qty'), parseInt(b.getAttribute('data-to'),10)); });
    });
  }
  function jsonOrThrow(r){
    if(!r.ok) throw new Error('Cart request failed: ' + r.status + ' ' + r.url);
    return r.json();
  }
  function cartError(e){ if(window.console) console.error('[MONARCH cart]', e); }
  function refresh(){ return fetch(M.routes.cart).then(jsonOrThrow).then(render).catch(cartError); }
  function change(key,qty){ fetch(M.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(jsonOrThrow).then(render).catch(cartError); }
  function initCart(){
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var input=form.querySelector('[data-variant-input]'); var id=input?input.value:null; if(!id) return;
        var btn=form.querySelector('[data-add]');
        var span=btn?btn.querySelector('span'):null; var label=span?span.textContent:'';
        if(btn){ btn.disabled=true; } if(span){ span.textContent='Adding\u2026'; }
        fetch(M.routes.cartAdd,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){return r.json();}).then(function(){return refresh();})
          .then(function(){ if(span){ span.textContent='Added \u2713'; } openDrawer(); setTimeout(function(){ if(span) span.textContent=label; if(btn) btn.disabled=false; },1400); })
          .catch(function(err){console.error(err); if(span) span.textContent=label; if(btn) btn.disabled=false; });
      });
    });
    document.querySelectorAll('[data-buynow]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var form=btn.closest('[data-product-form]'); if(!form) return;
        var input=form.querySelector('[data-variant-input]'); var id=input?input.value:null; if(!id) return;
        btn.disabled=true;
        fetch(M.routes.cartAdd,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(){ window.location.href=(M.routes.root||'/').replace(/\/$/,'')+'/checkout'; })
          .catch(function(err){console.error(err); btn.disabled=false;});
      });
    });
    document.querySelectorAll('[data-cart-open]').forEach(function(b){
      b.addEventListener('click',function(e){
        e.preventDefault();
        openDrawer();
        refresh().catch(function(err){
          cartError(err);
          window.location.href = b.getAttribute('href') || '/cart';
        });
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click',closeDrawer); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });
  }

  function initParallax(){
    if(reduce) return;
    var el=document.querySelector('[data-parallax]'); if(!el) return;
    window.addEventListener('scroll',function(){ var y=window.scrollY; if(y<900) el.style.transform='translateY('+(y*0.05)+'px)'; },{passive:true});
  }


  function initProgress(){
    var bar=document.querySelector('[data-progress]'); if(!bar) return;
    var f=function(){ var h=document.documentElement; var max=h.scrollHeight-h.clientHeight; bar.style.width=(max>0?(h.scrollTop/max*100):0)+'%'; };
    window.addEventListener('scroll',f,{passive:true}); window.addEventListener('resize',f); f();
  }


  function initGallery(){
    document.querySelectorAll('[data-gallery]').forEach(function(g){
      var main=g.querySelector('[data-main]');
      var thumbs=g.querySelectorAll('[data-thumb]');
      thumbs.forEach(function(t){
        t.addEventListener('click',function(){
          var src=t.getAttribute('data-src'); if(src&&main) main.src=src;
          thumbs.forEach(function(x){ x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  function initZoom(){
    if(reduce) return;
    document.querySelectorAll('[data-zoom]').forEach(function(z){
      var img=z.querySelector('img'); if(!img) return;
      z.addEventListener('mousemove',function(e){
        var r=z.getBoundingClientRect();
        var x=((e.clientX-r.left)/r.width)*100;
        var y=((e.clientY-r.top)/r.height)*100;
        img.style.transformOrigin=x+'% '+y+'%';
      });
      z.addEventListener('mouseenter',function(){ z.classList.add('zooming'); });
      z.addEventListener('mouseleave',function(){ z.classList.remove('zooming'); img.style.transformOrigin='center'; });
    });
  }


  function initCartPageQty(){
    document.querySelectorAll('[data-line-qty]').forEach(function(b){
      b.addEventListener('click',function(e){
        e.preventDefault();
        var line=b.getAttribute('data-line'); var to=b.getAttribute('data-to');
        fetch(M.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(line,10),quantity:parseInt(to,10)})})
          .then(function(r){return r.json();}).then(function(){ window.location.reload(); });
      });
    });
  }


  function initSearch(){
    var ov=document.querySelector('[data-search-overlay]');
    if(!ov) return;
    var input=ov.querySelector('[data-search-input]');
    function open(){ ov.classList.add('is-open'); ov.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; setTimeout(function(){ if(input) input.focus(); },260); }
    function close(){ ov.classList.remove('is-open'); ov.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    document.querySelectorAll('[data-search-open]').forEach(function(b){ b.addEventListener('click',open); });
    document.querySelectorAll('[data-search-close]').forEach(function(b){ b.addEventListener('click',close); });
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && ov.classList.contains('is-open')) close(); });
  }


  function initStickyBuy(){
    var bar=document.querySelector('[data-sticky-buy]');
    if(!bar) return;
    var form=document.querySelector('[data-product-form]');
    var mainBtn=form?form.querySelector('[data-add]'):null;
    if(!mainBtn) return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ bar.classList.remove('is-up'); bar.setAttribute('aria-hidden','true'); }
        else if(e.boundingClientRect.top < 0){ bar.classList.add('is-up'); bar.setAttribute('aria-hidden','false'); }
      });
    },{threshold:0});
    io.observe(mainBtn);
    var sBtn=bar.querySelector('[data-sticky-add]');
    if(sBtn) sBtn.addEventListener('click',function(){ mainBtn.click(); });
  }


  function initCookies(){
    var bar=document.querySelector('[data-cookiebar]');
    if(!bar) return;
    function api(){ return (window.Shopify && window.Shopify.customerPrivacy) ? window.Shopify.customerPrivacy : null; }
    function alreadyChosen(){
      try{ return document.cookie.indexOf('_tracking_consent') !== -1 || localStorage.getItem('monarch_consent'); }
      catch(e){ return false; }
    }
    function setConsent(allow){
      try{ localStorage.setItem('monarch_consent', allow ? 'yes' : 'no'); }catch(e){}
      var a=api();
      if(a && typeof a.setTrackingConsent === 'function'){
        a.setTrackingConsent({ analytics: allow, marketing: allow, preferences: allow, sale_of_data: allow }, function(){});
      }
      bar.hidden=true;
      bar.classList.remove('is-up');
    }
    if(!alreadyChosen()){
      bar.hidden=false;
      setTimeout(function(){ bar.classList.add('is-up'); }, 900);
    }
    var acc=bar.querySelector('[data-cookie-accept]');
    var dec=bar.querySelector('[data-cookie-decline]');
    if(acc) acc.addEventListener('click', function(){ setConsent(true); });
    if(dec) dec.addEventListener('click', function(){ setConsent(false); });
  }

  function safe(name, fn){
    try { fn(); } catch(e){ if(window.console) console.warn('[MONARCH] ' + name + ' failed:', e); }
  }
  function boot(){
    safe('cart', initCart);
    safe('cartPageQty', initCartPageQty);
    safe('stickyBuy', initStickyBuy);
    safe('swatches', initSwatches);
    safe('gallery', initGallery);
    safe('zoom', initZoom);
    safe('header', initHeader);
    safe('menu', initMenu);
    safe('search', initSearch);
    safe('faq', initFaq);
    safe('reveals', startReveals);
    safe('progress', initProgress);
    safe('parallax', initParallax);
    safe('cookies', initCookies);
    safe('refresh', refresh);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();

/* ===== Video autoplay safety net (iOS/Safari sometimes blocks autoplay) ===== */
(function(){
  /* iOS and in-app browsers (TikTok, Instagram, Facebook) sometimes hand a
     playing <video> to the native fullscreen player. These are decorative
     background layers, so if that happens we bounce straight back out. */
  function blockFullscreen(v){
    function bounce(){
      try { if (typeof v.webkitExitFullscreen === 'function') v.webkitExitFullscreen(); } catch(e){}
      try { if (document.fullscreenElement === v && document.exitFullscreen) document.exitFullscreen(); } catch(e){}
      try { if (typeof v.webkitSetPresentationMode === 'function') v.webkitSetPresentationMode('inline'); } catch(e){}
    }
    v.addEventListener('webkitbeginfullscreen', bounce);
    v.addEventListener('fullscreenchange', bounce);
    v.addEventListener('webkitpresentationmodechanged', function(){
      if (v.webkitPresentationMode && v.webkitPresentationMode !== 'inline') bounce();
    });
  }

  /* Only play what's actually on screen — saves battery and mobile data,
     and stops off-screen videos from grabbing focus while scrolling. */
  function playWhenVisible(v){
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ v.play().catch(function(){}); }
        else if(!v.paused){ v.pause(); }
      });
    }, { threshold: 0.01 });
    io.observe(v);
  }

  function kickVideos(){
    var vids = document.querySelectorAll('video[autoplay]');
    vids.forEach(function(v){
      if(v.dataset.monarchReady) return;
      v.dataset.monarchReady = '1';
      v.muted = true;              // iOS requires muted for autoplay
      v.setAttribute('muted','');
      v.playsInline = true;
      v.setAttribute('playsinline','');
      v.setAttribute('webkit-playsinline','');
      v.controls = false;          // no native controls to tap into
      v.removeAttribute('controls');
      v.tabIndex = -1;             // not keyboard-focusable
      v.setAttribute('disablepictureinpicture','');
      try { v.disablePictureInPicture = true; } catch(e){}
      blockFullscreen(v);
      playWhenVisible(v);
      var p = v.play();
      if(p && typeof p.catch === 'function'){
        p.catch(function(){
          // Autoplay refused — start on the first user interaction instead
          var start = function(){
            v.play().catch(function(){});
            document.removeEventListener('touchstart', start);
            document.removeEventListener('click', start);
          };
          document.addEventListener('touchstart', start, {once:true, passive:true});
          document.addEventListener('click', start, {once:true});
        });
      }
    });
  }
  function boot(){ try { kickVideos(); } catch(e){ if(window.console) console.warn('[MONARCH video]', e); } }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  window.addEventListener('load', boot);
})();

/* ===== Welcome popup (self-contained) ===== */
(function(){
  function init(){
    var pop = document.querySelector('[data-welcome-popup]');
    if(!pop) return;
    var KEY='monarch_welcome_seen';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function seen(){ try{ return localStorage.getItem(KEY)==='1'; }catch(e){ return false; } }
    function markSeen(){ try{ localStorage.setItem(KEY,'1'); }catch(e){} }
    function open(){
      if(pop.classList.contains('is-open')) return;
      pop.hidden=false;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ pop.classList.add('is-open'); }); });
      document.body.style.overflow='hidden';
      var i=pop.querySelector('input[type=email]');
      setTimeout(function(){ if(i) i.focus(); },450);
    }
    function close(){
      pop.classList.remove('is-open');
      document.body.style.overflow='';
      markSeen();
      setTimeout(function(){ pop.hidden=true; },500);
    }
    /* Don't stack the popup on top of the cookie banner — wait until the
       visitor has answered consent, then give them a moment before asking
       for their email. */
    function cookieBarUp(){
      var bar=document.querySelector('[data-cookiebar]');
      return !!(bar && !bar.hidden && bar.classList.contains('is-up'));
    }
    function openWhenClear(){
      if(seen()) return;
      if(cookieBarUp()){ setTimeout(openWhenClear, 1500); return; }
      open();
    }
    if(pop.querySelector('[data-wpop-success]')){ open(); }
    else if(!seen()){
      var timer=setTimeout(openWhenClear, 8000);
      if(!reduce){
        document.addEventListener('mouseout', function onOut(e){
          if(!e.relatedTarget && e.clientY<=0 && !seen()){
            clearTimeout(timer); openWhenClear(); document.removeEventListener('mouseout', onOut);
          }
        });
      }
    }
    pop.querySelectorAll('[data-wpop-close]').forEach(function(b){ b.addEventListener('click', close); });
    pop.addEventListener('click', function(e){ if(e.target===pop) close(); });
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape' && pop.classList.contains('is-open')) close();
    });
    var copyBtn=pop.querySelector('[data-wpop-copy]');
    if(copyBtn){
      copyBtn.addEventListener('click', function(){
        var code=copyBtn.getAttribute('data-code')||'';
        var label=copyBtn.querySelector('[data-wpop-copylabel]');
        function done(){ if(label){ label.textContent='Copied \u2713'; setTimeout(function(){ label.textContent='Copy'; },1800); } }
        if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done).catch(function(){}); }
        else {
          var t=document.createElement('textarea'); t.value=code; document.body.appendChild(t); t.select();
          try{ document.execCommand('copy'); done(); }catch(e){} document.body.removeChild(t);
        }
      });
    }
  }
  function boot(){ try{ init(); }catch(e){ if(window.console) console.warn('[MONARCH popup]', e); } }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();

/* ===== Product image lightbox (tap/click to view fullscreen) ===== */
(function(){
  function init(){
    var triggers = document.querySelectorAll('[data-gallery] [data-zoom]');
    if(!triggers.length) return;
    var box = document.createElement('div');
    box.className = 'lightbox';
    box.setAttribute('aria-hidden','true');
    box.innerHTML = '<button class="lightbox__close" type="button" aria-label="Close">×</button><img class="lightbox__img" alt="">';
    document.body.appendChild(box);
    var img = box.querySelector('.lightbox__img');
    function open(src){ if(!src) return; img.src = src; box.classList.add('is-open'); box.setAttribute('aria-hidden','false'); document.body.classList.add('u-noscroll'); }
    function close(){ box.classList.remove('is-open'); box.setAttribute('aria-hidden','true'); document.body.classList.remove('u-noscroll'); }
    triggers.forEach(function(t){
      t.addEventListener('click', function(){ var i = t.querySelector('img'); if(i) open(i.currentSrc || i.src); });
    });
    box.addEventListener('click', function(e){ if(e.target === box || e.target.classList.contains('lightbox__close')) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && box.classList.contains('is-open')) close(); });
  }
  function boot(){ try{ init(); }catch(e){ if(window.console) console.warn('[MONARCH lightbox]', e); } }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
